import { formatDistanceToNow, format } from "date-fns";

export const formatRelativeDate = (date) => {
  const now = new Date();
  const target = new Date(date);

  const diffDays = Math.floor(
    (now - target) / (1000 * 60 * 60 * 24)
  );

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";

  let text = formatDistanceToNow(target, { addSuffix: true });

  // Remove "about", "over", "almost"
  text = text.replace(/^(about|over|almost)\s+/i, "");

  // Capitalize first letter (optional, looks better)
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const formatDateDDMMYYYY = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const formatDateSafe = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return isNaN(date) ? "-" : format(date, "do MMMM yyyy");
};
